enum MailListContextMenuType {
    All,
    MoveTo,
    Categorize,
}

export default MailListContextMenuType;
